import moment from "moment";
import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterDateRangeBoxHandler from "./IDataFilterDateRangeBoxHandler";
import IDataFilterDateRangeValue from "./IDataFilterDateRangeValue";

export default class DataFilterDateRangeBoxHandler
  implements IDataFilterDateRangeBoxHandler {
  setDescriptorValuesFromUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    
    const storeFrom = moment(urlParams.get(`${descriptor.name}From`))
    .format("DD.MM.YYYY");

    const storeTo = moment(urlParams.get(`${descriptor.name}To`))
    .format("DD.MM.YYYY");

    (descriptor.value as IDataFilterDateRangeValue).from =
      storeFrom === "Invalid date" ? "" : storeFrom;
    (descriptor.value as IDataFilterDateRangeValue).to =
      storeTo === "Invalid date" ? "" : storeTo;
  }

  setDescriptorValuesToUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    const dateRangeValue = descriptor.value as IDataFilterDateRangeValue;

    if (dateRangeValue.from) {
      const dfrom = moment(dateRangeValue.from, "DD.MM.YYYY")
        .utc(true)
        .toISOString(false);
      urlParams.set(`${descriptor.name}From`, dfrom);
    } else {
      urlParams.delete(`${descriptor.name}From`);
    }

    if (dateRangeValue.to) {
      const dto = moment(dateRangeValue.to, "DD.MM.YYYY")
        .endOf("day")
        .toISOString(true);

      urlParams.set(`${descriptor.name}To`, dto);
    } else {
      urlParams.delete(`${descriptor.name}To`);
    }
  }
}
